import type { Verdict } from "../../shared/types";
import { Badge } from "./Badge";

const VERDICT_LABEL: Record<
  Verdict,
  {
    text: string;
    emoji: string;
    tone: "good" | "warn" | "bad" | "neutral" | "highlight";
    description: string;
  }
> = {
  best: {
    text: "BEST",
    emoji: "★",
    tone: "highlight",
    description:
      "Strong bet. Our independent model AND the sharp-book consensus both say this is mispriced in your favor, and their probability estimates agree closely. This is the configuration historically worth a stake.",
  },
  good: {
    text: "GOOD",
    emoji: "👍",
    tone: "good",
    description:
      "One signal says this bet is mispriced in your favor (either our model or the sharp consensus, not both). Worth considering but not as strong as a BEST.",
  },
  ok: {
    text: "OK",
    emoji: "✓",
    tone: "neutral",
    description:
      "A reasonable favourite — likely to win more often than not — but no evidence of a price edge. Betting these long-term loses about the bookmaker's margin.",
  },
  avoid: {
    text: "AVOID",
    emoji: "⚠",
    tone: "bad",
    description: "Not a meaningful favourite. The model and/or the price say there's no edge here — skip.",
  },
};

/**
 * Plain-English recommendation chip for a pick. The verdict is the *one*
 * piece of information a non-expert needs to know what to do with a row,
 * without reading any other number.
 */
export function VerdictBadge({ verdict }: { verdict: Verdict }) {
  const v = VERDICT_LABEL[verdict];
  return (
    <Badge tone={v.tone === "highlight" ? "highlight" : v.tone} title={v.description}>
      {v.emoji} {v.text}
    </Badge>
  );
}

export function verdictLabel(verdict: Verdict): string {
  return VERDICT_LABEL[verdict].text;
}
